globalThis.backoffice = globalThis.backoffice || {};

backoffice.ModalCreateSpecificDealItem = (function(superClass)
{
    utils.extend(ModalCreateSpecificDealItem, superClass);

    function ModalCreateSpecificDealItem($html) {
      return ModalCreateSpecificDealItem.__super__.constructor.apply(this, arguments);
    }

    $.extend(ModalCreateSpecificDealItem.prototype, {
      init: function()
      {
        $(".styled").uniform({
            radioClass: 'choice'
        });

        ModalCreateSpecificDealItem.__super__.init.apply(this, arguments);
      },
      callbackSuccess: function(data) {
        if(data.response) {
          location.reload();
        }

        ModalCreateSpecificDealItem.__super__.callbackSuccess.apply(this, arguments);
      }
    });

    return ModalCreateSpecificDealItem;
})(backoffice.ModalMain);
